module.exports = "/assets/data/4ccdc7739fcb36593061a3ff04221aab-UB4.data.json";